import { Link } from "react-router-dom";
import { useFocoNoTitulo, useTituloDoDocumento } from "./useTituloDoDocumento";

/*
 * O caminho que não leva a nada: uma linha e a saída para a lista.
 *
 * Link velho e identificador cortado no chat acontecem. A tela diz o fato e mantém a
 * barra lateral, em vez de redirecionar em silêncio, o que esconderia o link errado.
 */
export function NaoEncontrado({
  texto,
  para,
  rotuloDoLink,
}: {
  texto: string;
  para: string;
  rotuloDoLink: string;
}) {
  const titulo = useFocoNoTitulo();
  useTituloDoDocumento(texto);

  return (
    <section className="flex flex-col gap-2">
      <h1 ref={titulo} tabIndex={-1} className="text-titulo font-semibold focus:outline-none">
        {texto}
      </h1>
      <Link to={para} className="text-esferografica underline-offset-2 hover:underline">
        {rotuloDoLink}
      </Link>
    </section>
  );
}
